import { render } from "./planeDetail.vue?vue&type=template&id=ca0e91ac&scoped=true"
import script from "./planeDetail.vue?vue&type=script&lang=js"
export * from "./planeDetail.vue?vue&type=script&lang=js"

import "./planeDetail.vue?vue&type=style&index=0&id=ca0e91ac&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca0e91ac"]])

export default __exports__